import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '@bossanova/ui-kit';
import { AuthService } from './services/auth.service';
import { SeoService } from './services/seo.service';
import { APP_PATHS } from './app.paths';
import { environment } from '../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackDialogComponent } from './components/feedback-dialog/feedback-dialog.component';

@Component({
  imports: [RouterModule, HeaderComponent],
  selector: 'bn-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected title = environment.appName;
  protected authService = inject(AuthService);
  protected readonly paths = APP_PATHS;
  private readonly seoService = inject(SeoService);
  private readonly dialog = inject(MatDialog);

  openFeedbackDialog(): void {
    this.dialog.open(FeedbackDialogComponent, {
      width: '480px',
      data: { userId: this.authService.currentUser()?.userId },
    });
  }
}
